
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-insurance/family-cover",
      function () {
        return require("private-next-pages/health-insurance/family-cover/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health-insurance/family-cover"])
      });
    }
  